/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AutofocusMode {
}

export enum AutofocusMode_Enum {
  OFF = 0,
  AUTO = 1,
  MACRO = 2,
  CONTINUOUS_VIDEO = 3,
  CONTINUOUS_PHOTO = 4,
  CONTINUOUS_EDOF = 5,
  UNRECOGNIZED = -1,
}

export function autofocusMode_EnumFromJSON(object: any): AutofocusMode_Enum {
  switch (object) {
    case 0:
    case "OFF":
      return AutofocusMode_Enum.OFF;
    case 1:
    case "AUTO":
      return AutofocusMode_Enum.AUTO;
    case 2:
    case "MACRO":
      return AutofocusMode_Enum.MACRO;
    case 3:
    case "CONTINUOUS_VIDEO":
      return AutofocusMode_Enum.CONTINUOUS_VIDEO;
    case 4:
    case "CONTINUOUS_PHOTO":
      return AutofocusMode_Enum.CONTINUOUS_PHOTO;
    case 5:
    case "CONTINUOUS_EDOF":
      return AutofocusMode_Enum.CONTINUOUS_EDOF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AutofocusMode_Enum.UNRECOGNIZED;
  }
}

export function autofocusMode_EnumToJSON(object: AutofocusMode_Enum): string {
  switch (object) {
    case AutofocusMode_Enum.OFF:
      return "OFF";
    case AutofocusMode_Enum.AUTO:
      return "AUTO";
    case AutofocusMode_Enum.MACRO:
      return "MACRO";
    case AutofocusMode_Enum.CONTINUOUS_VIDEO:
      return "CONTINUOUS_VIDEO";
    case AutofocusMode_Enum.CONTINUOUS_PHOTO:
      return "CONTINUOUS_PHOTO";
    case AutofocusMode_Enum.CONTINUOUS_EDOF:
      return "CONTINUOUS_EDOF";
    case AutofocusMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAutofocusMode(): AutofocusMode {
  return {};
}

export const AutofocusMode = {
  encode(_: AutofocusMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AutofocusMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutofocusMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AutofocusMode {
    return {};
  },

  toJSON(_: AutofocusMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AutofocusMode>, I>>(base?: I): AutofocusMode {
    return AutofocusMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutofocusMode>, I>>(_: I): AutofocusMode {
    const message = createBaseAutofocusMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
